import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';
import { Container } from '@plone/components';

const Timestamp = (props) => {
  const now = Date.now();
  const label = 'Dados atualizados em';
  return (
    <Container narrow className={'timestamp'}>
      <span className="label">{label}:</span>{' '}
      <span className="datetime">
        <FormattedDate {...props} date={now} includeTime={false} />
      </span>
    </Container>
  );
};

export default Timestamp;
